import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import AutoSuggest from './widgets/AutoSuggest';

const autoSuggestDiv = document.getElementById('auto-suggest');
const attributes = autoSuggestDiv && {
    isLoggedIn:
        autoSuggestDiv.getAttribute('data-isloggedin').toLocaleLowerCase() ===
        'true',
    seachPage: autoSuggestDiv.getAttribute('data-searchpage'),
    marketData: autoSuggestDiv.getAttribute('data-market'),
    discountData: autoSuggestDiv.getAttribute('data-discount')
};

import './i18n';

autoSuggestDiv &&
    ReactDOM.createRoot(document.getElementById('auto-suggest')).render(
        <BrowserRouter>
            <AutoSuggest {...attributes} />
        </BrowserRouter>
    );
